import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth } from '../firebase';

export default function PreApprovals() {
  const navigate = useNavigate();
  const [selectedApproval, setSelectedApproval] = useState('Approval for Capital Loan');
  const [approvals, setApprovals] = useState([
    { id: 1, name: 'Approval for Project', completed: true },
    { id: 2, name: 'Approval for Capital Funding', completed: true },
    { id: 3, name: 'Approval for Capital Loan', completed: true },
    { id: 4, name: 'Approval for Project Loan', completed: true },
    { id: 5, name: 'Approval for Construction', completed: true },
    { id: 6, name: 'Project Financial Information', completed: true },
    { id: 7, name: 'Offering Memorandum', completed: true }
  ]);

  const loanDetails = [
    { type: 'Loan Service', description: 'Service Charges', loan: '1', term: '$74,900' },
    { type: 'Loan Total', description: 'Total Amount', loan: '1', term: '$10,000,000' },
    { type: 'Loan Items', description: 'Construction Materials', loan: '1', term: '$5,500,000' },
    { type: 'Loan Items', description: 'Construction Labor', loan: '1', term: '$4,500,000' }
  ];

  const handleLogout = () => {
    auth.signOut();
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', backgroundColor: '#000000' }}>
      {/* Left Sidebar Navigation */}
      <div style={{ 
        width: '80px', 
        backgroundColor: '#2D2D2D', 
        display: 'flex', 
        flexDirection: 'column',
        alignItems: 'center',
        paddingTop: '2rem',
        gap: '2rem'
      }}>
        {/* Dashboard Icon */}
        <div style={{
          width: '48px',
          height: '48px',
          backgroundColor: '#8B5CF6',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer'
        }}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="white">
            <rect x="3" y="3" width="7" height="7" />
            <rect x="14" y="3" width="7" height="7" />
            <rect x="3" y="14" width="7" height="7" />
            <rect x="14" y="14" width="7" height="7" />
          </svg>
        </div>

        {/* Network Icon */}
        <div style={{
          width: '48px',
          height: '48px',
          backgroundColor: 'transparent',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          border: '2px solid white'
        }}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="white">
            <circle cx="12" cy="12" r="2" />
            <circle cx="12" cy="5" r="2" />
            <circle cx="12" cy="19" r="2" />
            <circle cx="5" cy="12" r="2" />
            <circle cx="19" cy="12" r="2" />
            <line x1="12" y1="7" x2="12" y2="9" stroke="white" strokeWidth="2" />
            <line x1="12" y1="15" x2="12" y2="17" stroke="white" strokeWidth="2" />
            <line x1="7" y1="12" x2="9" y2="12" stroke="white" strokeWidth="2" />
            <line x1="15" y1="12" x2="17" y2="12" stroke="white" strokeWidth="2" />
          </svg>
        </div>

        {/* People Icon */}
        <div style={{
          width: '48px',
          height: '48px',
          backgroundColor: 'transparent',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          border: '2px solid white'
        }}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="white">
            <path d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
            <path d="M8 7a2 2 0 114 0 2 2 0 01-4 0z" />
            <path d="M16 7a2 2 0 114 0 2 2 0 01-4 0z" />
          </svg>
        </div>

        {/* Calendar Icon */}
        <div style={{
          width: '48px',
          height: '48px',
          backgroundColor: 'transparent',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          border: '2px solid white'
        }}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="white">
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2" stroke="white" strokeWidth="2" fill="none" />
            <line x1="16" y1="2" x2="16" y2="6" stroke="white" strokeWidth="2" />
            <line x1="8" y1="2" x2="8" y2="6" stroke="white" strokeWidth="2" />
            <line x1="3" y1="10" x2="21" y2="10" stroke="white" strokeWidth="2" />
          </svg>
        </div>
      </div>

      {/* Main Content Area */}
      <div style={{ flex: 1, backgroundColor: '#000000', display: 'flex', flexDirection: 'column' }}>
        {/* Header */}
        <header style={{ 
          padding: '1rem 2rem',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          borderBottom: '1px solid #333'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
            {/* Back to Dashboard Button */}
            <button
              onClick={() => navigate('/dashboard')}
              style={{
                backgroundColor: '#2D2D2D',
                color: 'white',
                padding: '0.75rem 1.5rem',
                borderRadius: '8px',
                border: 'none',
                fontSize: '1rem',
                fontWeight: '500',
                cursor: 'pointer'
              }}
            >
              ← Dashboard
            </button>

            {/* Search Icon */}
            <div style={{ color: 'white', cursor: 'pointer' }}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
                <circle cx="11" cy="11" r="8" stroke="white" strokeWidth="2" fill="none" />
                <path d="m21 21-4.35-4.35" stroke="white" strokeWidth="2" fill="none" />
              </svg>
            </div>
            
            {/* Gear Icon */}
            <div style={{ color: 'white', cursor: 'pointer' }}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
                <circle cx="12" cy="12" r="3" stroke="white" strokeWidth="2" fill="none" />
                <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1 1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" stroke="white" strokeWidth="2" fill="none" />
              </svg>
            </div>

            {/* Get Loan Button */}
            <button style={{
              backgroundColor: '#8B5CF6',
              color: 'white',
              padding: '0.75rem 1.5rem',
              borderRadius: '8px',
              border: 'none',
              fontSize: '1rem',
              fontWeight: '500',
              cursor: 'pointer'
            }}>
              Get Loan
            </button>
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
            {/* Folder Icon */}
            <div style={{ color: 'white', cursor: 'pointer' }}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
                <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z" stroke="white" strokeWidth="2" fill="none" />
              </svg>
            </div>

            {/* Square Icon */}
            <div style={{ color: 'white', cursor: 'pointer' }}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
                <rect x="3" y="3" width="18" height="18" rx="2" ry="2" stroke="white" strokeWidth="2" fill="none" />
              </svg>
            </div>

            {/* Help Icon */}
            <div style={{ color: 'white', cursor: 'pointer' }}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
                <circle cx="12" cy="12" r="10" stroke="white" strokeWidth="2" fill="none" />
                <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" stroke="white" strokeWidth="2" fill="none" />
                <line x1="12" y1="17" x2="12.01" y2="17" stroke="white" strokeWidth="2" fill="none" />
              </svg>
            </div>

            {/* Settings Icon */}
            <div style={{ color: 'white', cursor: 'pointer' }}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
                <circle cx="12" cy="12" r="3" stroke="white" strokeWidth="2" fill="none" />
                <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1 1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" stroke="white" strokeWidth="2" fill="none" />
              </svg>
            </div>

            {/* Profile Icon */}
            <div style={{
              width: '32px',
              height: '32px',
              backgroundColor: '#2D2D2D',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer'
            }}>
              <div style={{
                width: '24px',
                height: '24px',
                backgroundColor: '#8B5CF6',
                borderRadius: '50%'
              }}></div>
            </div>
          </div>
        </header>

        {/* Main Content */}
        <div style={{ display: 'flex', flex: 1 }}>
          {/* Left Panel - Pre-Approvals */}
          <div style={{ 
            width: '40%', 
            backgroundColor: '#000000', 
            padding: '2rem',
            borderRight: '1px solid #333'
          }}>
            <h1 style={{ 
              fontSize: '2rem', 
              fontWeight: 'bold', 
              color: 'white',
              marginBottom: '2rem'
            }}>
              Pre-Approvals
            </h1>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
              {approvals.map((approval) => (
                <div
                  key={approval.id}
                  onClick={() => setSelectedApproval(approval.name)}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.75rem',
                    padding: '0.75rem',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    backgroundColor: selectedApproval === approval.name ? '#2D2D2D' : 'transparent',
                    transition: 'background-color 0.2s'
                  }}
                >
                  <div style={{
                    width: '20px',
                    height: '20px',
                    backgroundColor: '#8B5CF6',
                    borderRadius: '4px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="white">
                      <polyline points="20,6 9,17 4,12" stroke="white" strokeWidth="2" fill="none" />
                    </svg>
                  </div>
                  <span style={{ color: 'white', fontSize: '0.875rem' }}>
                    {approval.name}
                  </span>
                </div>
              ))}
            </div>

            {/* TradeTapp Button */}
            <div style={{ marginTop: '3rem' }}>
              <button style={{
                backgroundColor: '#8B5CF6',
                color: 'white',
                padding: '0.75rem 1.5rem',
                borderRadius: '8px',
                border: 'none',
                fontSize: '0.875rem',
                fontWeight: '500',
                cursor: 'pointer',
                width: '100%'
              }}>
                TradeTapp
              </button>
            </div>
          </div>

          {/* Right Panel - Loan Details */}
          <div style={{ 
            flex: 1, 
            backgroundColor: '#000000', 
            padding: '2rem',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'flex-start'
          }}>
            <div style={{
              backgroundColor: '#1A1A1A',
              borderRadius: '12px',
              padding: '2rem',
              width: '100%',
              maxWidth: '600px',
              position: 'relative'
            }}>
              {/* Action Icons */}
              <div style={{ 
                position: 'absolute', 
                top: '1.5rem', 
                right: '1.5rem',
                display: 'flex',
                gap: '0.75rem'
              }}>
                {/* Edit Icon */}
                <div style={{ color: 'white', cursor: 'pointer' }}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
                    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" stroke="white" strokeWidth="2" fill="none" />
                    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" stroke="white" strokeWidth="2" fill="none" />
                  </svg>
                </div>

                {/* Print Icon */}
                <div style={{ color: 'white', cursor: 'pointer' }}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
                    <polyline points="6,9 6,2 18,2 18,9" stroke="white" strokeWidth="2" fill="none" />
                    <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" stroke="white" strokeWidth="2" fill="none" />
                    <rect x="6" y="14" width="12" height="8" stroke="white" strokeWidth="2" fill="none" />
                  </svg>
                </div>

                {/* Upload Icon */}
                <div style={{ color: 'white', cursor: 'pointer' }}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" stroke="white" strokeWidth="2" fill="none" />
                    <polyline points="7,10 12,5 17,10" stroke="white" strokeWidth="2" fill="none" />
                    <line x1="12" y1="5" x2="12" y2="15" stroke="white" strokeWidth="2" fill="none" />
                  </svg>
                </div>

                {/* Delete Icon */}
                <div style={{ color: 'white', cursor: 'pointer' }}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
                    <polyline points="3,6 5,6 21,6" stroke="white" strokeWidth="2" fill="none" />
                    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" stroke="white" strokeWidth="2" fill="none" />
                  </svg>
                </div>
              </div>

              {/* Title */}
              <h2 style={{ 
                fontSize: '1.5rem', 
                fontWeight: 'bold', 
                color: 'white',
                marginBottom: '1.5rem'
              }}>
                Loan Details
              </h2>

              {/* Contractor and Bidder Info */}
              <div style={{ marginBottom: '2rem' }}>
                <div style={{ marginBottom: '1rem' }}>
                  <h3 style={{ color: 'white', fontSize: '0.875rem', fontWeight: '600', marginBottom: '0.5rem' }}>
                    Contractor:
                  </h3>
                  <p style={{ color: '#999', fontSize: '0.875rem', margin: 0 }}>
                    Approved Financial Institution Loan Terms Secure Payments
                  </p>
                </div>
                <div>
                  <h3 style={{ color: 'white', fontSize: '0.875rem', fontWeight: '600', marginBottom: '0.5rem' }}>
                    Bidder:
                  </h3>
                  <p style={{ color: '#999', fontSize: '0.875rem', margin: 0 }}>
                    Bidding Institution Flexible Terms Real-Time Tracking
                  </p>
                </div>
              </div>

              {/* Loan Details Table */}
              <div style={{ marginBottom: '2rem' }}>
                <div style={{ 
                  display: 'grid', 
                  gridTemplateColumns: '1fr 1.5fr 0.5fr 1fr',
                  gap: '1rem',
                  marginBottom: '1rem'
                }}>
                  <div style={{ color: 'white', fontSize: '0.875rem', fontWeight: '600' }}>Loan Type</div>
                  <div style={{ color: 'white', fontSize: '0.875rem', fontWeight: '600' }}>Loan Description</div>
                  <div style={{ color: 'white', fontSize: '0.875rem', fontWeight: '600' }}>Loan</div>
                  <div style={{ color: 'white', fontSize: '0.875rem', fontWeight: '600' }}>Loan Term</div>
                </div>

                {loanDetails.map((detail, index) => (
                  <div key={index} style={{ 
                    display: 'grid', 
                    gridTemplateColumns: '1fr 1.5fr 0.5fr 1fr',
                    gap: '1rem',
                    padding: '0.75rem 0',
                    borderBottom: index < loanDetails.length - 1 ? '1px solid #333' : 'none'
                  }}>
                    <div style={{ color: 'white', fontSize: '0.875rem' }}>{detail.type}</div>
                    <div style={{ color: 'white', fontSize: '0.875rem' }}>{detail.description}</div>
                    <div style={{ color: 'white', fontSize: '0.875rem' }}>{detail.loan}</div>
                    <div style={{ color: 'white', fontSize: '0.875rem' }}>{detail.term}</div>
                  </div>
                ))}

                <p style={{ color: '#999', fontSize: '0.75rem', marginTop: '1rem', marginBottom: 0 }}>
                  All loans are in USD, fees may apply.
                </p>
              </div>

              {/* Totals */}
              <div style={{ borderTop: '1px solid #333', paddingTop: '1rem' }}>
                <div style={{ 
                  display: 'flex', 
                  justifyContent: 'space-between', 
                  marginBottom: '0.5rem' 
                }}>
                  <span style={{ color: 'white', fontSize: '0.875rem' }}>Loan Subtotal</span>
                  <span style={{ color: 'white', fontSize: '0.875rem' }}>$74,900</span>
                </div>
                <div style={{ 
                  display: 'flex', 
                  justifyContent: 'space-between',
                  borderTop: '1px solid #333',
                  paddingTop: '0.5rem'
                }}>
                  <span style={{ color: 'white', fontSize: '1rem', fontWeight: 'bold' }}>
                    Loan Total Including Fees
                  </span>
                  <span style={{ color: 'white', fontSize: '1rem', fontWeight: 'bold' }}>
                    $10,074,900
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
